import { render, staticRenderFns } from "./ProductTileImageBanner.vue?vue&type=template&id=563657f4&"
import script from "./ProductTileImageBanner.vue?vue&type=script&lang=js&"
export * from "./ProductTileImageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
